import AppContainer from '@/views/app/app-container'
import CustomersRouter from '@/router/app/customers'
import TasksRouter from '@/router/app/tasks'
import CampaignsRouter from '@/router/app/campaigns'
import DashboardRouter from '@/router/app/dashboard'
import GoalsRouter from '@/router/app/goals'
import ReportRouter from '@/router/app/report'
import DealerRouter from '@/router/app/dealer'
import ReassignmentRouter from '@/router/app/reassignment'
import store from '@/store'
export default [
  {
    path: '/app',
    name: 'App',
    component: AppContainer,
    beforeEnter (to, from, next) {
      return store.dispatch('profile/me')
        .then(next)
        .catch(next)
    },
    children: [
      ...CustomersRouter,
      ...TasksRouter,
      ...CampaignsRouter,
      ...DashboardRouter,
      ...GoalsRouter,
      ...ReportRouter,
      ...DealerRouter,
      ...ReassignmentRouter
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/index.js